import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { getDraftPropertyInsuranceList } from '../../redux/modules/insurances';
import { tableDateFormat } from '../../helpers/dates';
import { PROPERTY_CONTRACT_SIGN_PATH } from '../../constants/routes';
import DraftInsurancesTable from './DraftInsurancesTable';
import { continueFromDraft } from '../../redux/modules/propertyContract';

const DraftPropertyInsurancesTable = () => {
  const { tblData, isLoading } = useSelector(
    (store) => store.insurances.draftPropertyInsuranceList, shallowEqual,
  );

  const columns = [
    {
      title: 'insuranceList.contractNumber',
      property: 'draftId',
      sortable: false,
      format: (v) => v.split('_')[3],
    },
    {
      title: 'insuranceList.from',
      property: 'contractStart',
      sortable: false,
      format: tableDateFormat,
    },
    {
      title: 'insuranceList.to',
      property: 'contractEnd',
      sortable: false,
      format: tableDateFormat,
    },
  ];

  return (
    <DraftInsurancesTable
      title="insuranceList.draftPropertyInsurances"
      uri={PROPERTY_CONTRACT_SIGN_PATH}
      columns={columns}
      tblData={tblData}
      isLoading={isLoading}
      getDraftInsuranceList={getDraftPropertyInsuranceList}
      continueFromDraft={continueFromDraft}
    />
  );
};

export default DraftPropertyInsurancesTable;
